"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ScheduledHeroEventStudentListItemDto = void 0;
const mappable_base_1 = require("../../mappable.base");
const class_transformer_1 = require("class-transformer");
class ScheduledHeroEventStudentListItemDto extends mappable_base_1.MappableBase {
    constructor(options) {
        super();
        Object.assign(this, options);
    }
    getFields() {
        return [
            'id',
            'studentId',
            'name',
            'grade',
            'checkInTimes',
            'checkOutTimes',
            'studentExtId'
        ];
    }
    id;
    studentId;
    name;
    grade;
    checkInTimes;
    checkOutTimes;
    studentExtId;
}
exports.ScheduledHeroEventStudentListItemDto = ScheduledHeroEventStudentListItemDto;
__decorate([
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Number)
], ScheduledHeroEventStudentListItemDto.prototype, "id", void 0);
__decorate([
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Number)
], ScheduledHeroEventStudentListItemDto.prototype, "studentId", void 0);
__decorate([
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], ScheduledHeroEventStudentListItemDto.prototype, "name", void 0);
__decorate([
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], ScheduledHeroEventStudentListItemDto.prototype, "grade", void 0);
__decorate([
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Array)
], ScheduledHeroEventStudentListItemDto.prototype, "checkInTimes", void 0);
__decorate([
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Array)
], ScheduledHeroEventStudentListItemDto.prototype, "checkOutTimes", void 0);
__decorate([
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], ScheduledHeroEventStudentListItemDto.prototype, "studentExtId", void 0);
